import { useOutletContext, useParams } from 'react-router-dom';
import type { SeasonContext } from '../lib/seasonContext.ts';
import { DraftAward } from './DraftAward.tsx';
import { SurvivorAward } from './SurvivorAward.tsx';

/**
 * `/award/:awardId`, routed by what the award computes rather than by its id,
 * so a league that renames its pools still lands on the right page.
 */
export function AwardPage() {
  const { awardId } = useParams<{ awardId: string }>();
  const { stored } = useOutletContext<SeasonContext>();
  const rule = stored.bundle.money.config.awards.find((a) => a.id === awardId);
  if (rule?.compute?.kind === 'survivor') return <SurvivorAward rule={rule} />;
  return <DraftAward />;
}
